export default __webpack_public_path__ + "static/media/A_wdt_c_cap_1.5e993a00.mp3";